export default "__VITE_ASSET__27db1ee6__"